import { JobsBrowser as JobsBrowserView } from './jobs-browser';
import { JobsBrowserProvider } from './jobs-browser.provider';

export const JobsBrowser = () => (
   <JobsBrowserProvider>
      <JobsBrowserView />
   </JobsBrowserProvider>
);

export const FeatureJobsBrowser = JobsBrowser;
